import { createModule } from 'saga-slice';
import {
    loadingReducer, readOneSuccess, failReducer, readAllSuccess
} from 'saga-slice-helpers';
import { sagaApi } from '#/apis';

const sagaSlice = createModule({

    name: 'unit-types',
    initialState: {
        isFetching: false,
        data: {},
        mappings: null,
        error: null
    },

    // Reducers object is the bread and butter of saga slice.
    // Defining a reducer also defines a type and action.
    // The type will be `todos/fetch`, using the pattern of `{name}/{key}`
    reducers: {
        readOne: loadingReducer,
        readOneSuccess: readOneSuccess,
        readOneFail: failReducer,

        readAll: loadingReducer,
        readAllSuccess: readAllSuccess,
        readAllFail: failReducer,


        fetchUnitTypeMappings: loadingReducer,
        fetchUnitTypeMappingsSuccess: (state, payload) => {

            state.mappings = payload;
            state.isFetching = false;
        },
        fetchUnitTypeMappingsFail: failReducer

    },

    // The sagas option is a function that gets passed the Actions object.
    // Actions are converted into strings which are the value of its
    // corresponding type. You can also use the actions object to dispatch
    // actions from sagas using the `put` effect.
    sagas: A => ({
        [A.fetchUnitTypeMappings]: function* () {
            yield sagaApi.get('/fetch-unit-type-mappings', A.fetchUnitTypeMappingsSuccess, A.fetchUnitTypeMappingsFail);
        },
        [A.readOne]: {
            *saga ({ payload }) {
                const {
                    propertyId, unitTypeId
                } = payload;
                yield sagaApi.get(
                    `/properties/${propertyId}/unit-types/${unitTypeId}`,
                    A.readOneSuccess,
                    A.readOneFail
                );
            }
        },
        [A.readAll]: {
            *saga ({ payload: propertyId }) {
                yield sagaApi.get(
                    `/properties/${propertyId}/unit-types`,
                    A.readAllSuccess,
                    A.readAllFail
                );
            }
        }
    })
});

// Export actions for convenience when importing from other modules
export const { actions } = sagaSlice;
export default sagaSlice;
